import * as React from 'react';

import ListModel from 'src/model/list.model';

import './Summary.scss';
import env from 'src/shared/env';

interface ISummaryProps {
  selectedList: number | string;
  lists: ListModel[];
  onCreateList: () => void;
  onClickFavorites: () => void;
  onClickCommonPurchases: () => void;
  onClickTopParts: () => void;
  onClickList: (id: number) => void;
  t?: any;
}

class Summary extends React.Component<ISummaryProps, any> {
  public render() {
    const { t } = this.props;
    return (
      <div className="rp-lists-summary">
        <div
          className="rp-lists-summary-item new-list"
          onClick={this.props.onCreateList}
        >
          <span className="rpds-add" />
          {t('myFavourites.createNewList')}
        </div>
        <div
          className={`rp-lists-summary-item ${this.props.selectedList ===
            'favorites' && 'rp-list-selected'}`}
          onClick={this.props.onClickFavorites}
        >
          <span className="rpds-star-border" />
          {/* {t('myFavourites.breadCrumb')} */}
          {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? t('myFavourites.breadCrumbCA')
            : t('myFavourites.breadCrumb')}
        </div>
        <div
          className={`rp-lists-summary-item ${this.props.selectedList ===
            'common' && 'rp-list-selected'}`}
          onClick={this.props.onClickCommonPurchases}
        >
          <span className="rpds-list" />
          {t('myFavourites.myFrequentPurchases')}
        </div>
        <div
          style={{ wordBreak: 'break-word' }}
          className={`rp-lists-summary-item ${this.props.selectedList ===
            'top' && 'rp-list-selected'}`}
          onClick={this.props.onClickTopParts}
        >
          <span className="rpds-list" />
          {t('myFavourites.reliableTopParts')}
        </div>
        {this.props.lists &&
          this.props.lists.map(list => {
            return (
              <React.Fragment key={list.listNumber}>
                {!list.favorite && (
                  <div
                    className={`rp-lists-summary-item ${(this.props
                      .selectedList === list.listNumber ||
                      this.props.selectedList === list.name) &&
                      'rp-list-selected'}`}
                    onClick={e => this.props.onClickList(list.listNumber)}
                  >
                    <span className="rpds-list" />
                    {list.name}
                  </div>
                )}
              </React.Fragment>
            );
          })}
      </div>
    );
  }
}

export default Summary;
